module.exports = __webpack_public_path__ + "img/box_right.09b56dc6.png";